import { render, staticRenderFns } from "./DeliveryAddress.vue?vue&type=template&id=f4661b8e&scoped=true&"
import script from "./DeliveryAddress.vue?vue&type=script&lang=js&"
export * from "./DeliveryAddress.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryAddress.vue?vue&type=style&index=0&id=f4661b8e&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4661b8e",
  null
  
)

export default component.exports